import { useRef } from 'react';

import ImageWithFallback from '../../../../../ImageWithFallback/ImageWithFallback';
import { useVwToPx } from '../../../../hooks/useVwToPx';

import classes from './RipsPackRewardComponent.module.scss';

type RipsPackRewardComponentProps = {
  imageUrl?: string;
  name?: string;
  /** Opens granted — rendered like the metagame token amount pill when > 1. */
  quantity?: number;
};

// Stable selector so the claim-flourish animation can locate + measure the rendered pack image
// from outside this component's tree (see RipsPackClaimFly).
export const RIPS_PACK_REWARD_IMAGE_TEST_ID = 'rips-pack-reward-image';

// Front image + the quantity when the gift grants more than one open, shown as the SAME purple
// amount pill metagame tokens use (MetaGameRewardComponent) — one visual language for "you get N".
const RipsPackRewardComponent = ({ imageUrl, name, quantity }: RipsPackRewardComponentProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const fontSize = useVwToPx({ ref, vwValue: 19 });

  if (!imageUrl) return null;

  return (
    <div ref={ref} className={classes.ripsPackReward}>
      <ImageWithFallback
        alt={name || 'Rips pack'}
        className={classes.image}
        dataTestId={RIPS_PACK_REWARD_IMAGE_TEST_ID}
        src={imageUrl}
      />
      {(quantity ?? 1) > 1 && (
        <span className={classes.quantityPill} style={{ fontSize }}>
          {quantity}
        </span>
      )}
    </div>
  );
};

export default RipsPackRewardComponent;
